var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"usage",style:({'font-size':'150%','color':_vm.color})},[_c('span',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }